import Vue from 'vue'

const status = {
	LOADING : Symbol('LOADING'),
	ERROR: Symbol('ERROR'),
	DATA: Symbol('DATA')
}

const error = {
	NOTLOGGEDIN: Symbol('NOTLOGGEDIN'),
	NORESPONSE: Symbol('NORESPONSE'),
	INTERNAL: Symbol('INTERNAL'),
}

var Constants = {	
	install: function (Vue, options) {
		var cons = {
	    	STATUS : status,
	    	ERROR : error		
	    };    	
		
		Vue.$cons = cons;
		Vue.prototype.$cons = cons;
	}
}

Vue.use(Constants)



// WEBPACK FOOTER //
// ./src/javascript/plugins/constants.js